export const DEFAULT_DATE_PICKER_STATE = {
    stateSelectDayValue: '',
    stateSelectMonthValue: '',
    stateSelectYearValue: '',
    stateSelectDayOptions: [],
    stateSelectMonthOptions: [],
    stateSelectYearOptions: []
};

export const DATE_PART = {
    day: 'DD',
    month: 'MM',
    year: 'YYYY'
};
